export default __webpack_public_path__ + "static/media/ssd.f2fd7e43.png";